import API from 'src/api'
import { http } from '../boot/axios'
import utils from 'src/utils'
import { Capacitor } from '@capacitor/core'

export default {
  GRAPHQL_URL: `${API.GRAPHQL_URL}routines`,

  createRoutine (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}`, payload)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  scheduleRoutine (routineId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/schedule/${routineId}`)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  getFilteredRoutines (payload) {
    const filters = { params: payload }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/getFilteredRoutines`, filters)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  updateRoutine (payload) {
    const routineId = payload.id
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/update/${routineId}`, payload)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  // TKT-2245 Fase 2 — solo lectura, no muta la rutina.
  previewUpdate (payload) {
    const routineId = payload.id
    return http.post(`${this.GRAPHQL_URL}/previewUpdate/${routineId}`, payload)
      .then(response => response.data)
  },
  finishRoutine (id) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/updateToFinish/${id}`)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  deleteRoutine (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${id}`)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  getFastTrackingData (params) {
    const payload = { params: params }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/fastTrackingData`, payload)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  downloadFastTrackingReport (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/downloadFastTrackingReport`, {
        params: payload,
        responseType: 'blob'
      })
        .then(async res => {
          if (Capacitor.isNativePlatform()) {
            utils.download(`Reporte de seguimiento rápido.pdf`, res.data, 'application/pdf')
          } else {
            const { saveAs } = await import('file-saver')
            saveAs(new Blob([res.data], { type: 'application/pdf' }), 'Reporte de seguimiento rápido.pdf')
          }
          resolve(res)
        })
        .catch(err => reject(err))
    })
  },
  getUserRoutines () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/getUserRoutines`)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  }
}
